
import Document from "../../../assets/outline/Document.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentIcon({ className, dataTestid = "DocumentIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Document data-testid={dataTestid} className={classes} {...rest} />
  );
}
